/*
目次：
カレンダーで選択した日付を取得のfunction
予約が入っている日を取得（ページを読み込んだ時のカレンダー）
      カレンダー設定
			日付を選択した時
詳細モーダルopen
キャンセルモーダルopen
キャンセル理由に文字を追加したらキャンセル確定ボタンを押下可能とする
キャンセル確定ボタン押下
*/


import { Calendar } from '@fullcalendar/core'
import dayGridPlugin from '@fullcalendar/daygrid';
import jaLocale from '@fullcalendar/core/locales/ja';
// dateClickに必要
import interactionPlugin from '@fullcalendar/interaction';
var moment = require("moment");
import MicroModal from 'micromodal';
import PerfectScrollbar from 'perfect-scrollbar';
jQuery(function($){
	if ($('.reserve.company-reserve').length > 0){
		// ローディング開始
		$(".main").prepend(sLoadingHtml2).hide().fadeIn(100);

		function addReserve() {
			/* **************************
			カレンダーで選択した日付を取得
			*/
			var reserveDay = $('.js-reserve-day').val();
			$.ajax({
				/*
				カレンダーを選択したら、業者のその日の予約状況・履歴情報を取得する
				*/
				url: "/mypage/company/reserve/getReserve/" + reserveDay,
				type:'GET',
				datatype:'json',
				timeout:30000
			}).
			done(function(oData){
				if(oData.status == 'success'){
					$('.js-reserve-list').html('');
					function addReserveInfo() {
						$.each(oData.reserves, function(i, aDatas){
							var day = moment(aDatas.start_time).format('yy/M/D');
							var timeTagDay = moment(aDatas.start_time).format('yy-M-D');
							var time = moment(aDatas.start_time).format('H:mm');
							var timeTagTime = moment(aDatas.start_time).format('H:mm');
							var reserveTime = moment(aDatas.reserve_datetime).format('yy/M/D H:mm');
							var amount = Number(aDatas.amount).toLocaleString();
							var cancelFlug =  '';
							var twoBtn = ''
							if(aDatas.flg_cancel !=  'N') {
								var cancelFlug =  'reserved cancel';
								var twoBtn = 'solo';
							}else{
								var twoBtn = 'two-btn';
							}
							var sBoxHtml = '<article class="reserve-item '+ cancelFlug + '" data-id="'+ aDatas.reserve_id+'">';
							sBoxHtml += '<h2 class="reserve-heading">' + aDatas.title + '</h2>';
							sBoxHtml += '<div class="reserve-content-wrap">';
							sBoxHtml += '<dl class="reserve-content">';
							sBoxHtml += '<dt><span>正規</span><span>見積もり金額</span></dt>';
							sBoxHtml += '<dd><p>' + amount + '<span>円</span></p></dd>';
							sBoxHtml += '</dl>';
							sBoxHtml += '<dl class="reserve-content">';
							sBoxHtml += '<dt>実施日時</dt>';
							sBoxHtml += '<dd><time datetime="' + timeTagDay +'">' + day + '</time><time datetime="' + timeTagTime +'">' + time + '</dd>';
							sBoxHtml += '</dl>';
							sBoxHtml += '<dl class="reserve-content">';
							sBoxHtml += '<dt>必要な時間</dt>';
							sBoxHtml += '<dd>' + aDatas.require_time + '</dd>';
							sBoxHtml += '</dl>';
							sBoxHtml += '</div>';
							if(aDatas.answer_detail) {
								sBoxHtml += '<p class="reserve-text">' + aDatas.answer_detail+ '</p>';
							}
							sBoxHtml += '<dl class="desc-group date">';
							sBoxHtml += '<dt>予約した日時</dt>';
							sBoxHtml += '<dd>' + reserveTime + '</dd>';
							sBoxHtml += '</dl>';
							sBoxHtml += '<div class="button-wrap two-btn">';
							sBoxHtml += '<div class="button">';
							sBoxHtml += '<button type="button" class="js-reserve-detail">詳細を見る</button>';
							sBoxHtml += '</div>';
							if(aDatas.cancelable_company ==  true) {
								sBoxHtml += '<div class="button">';
								sBoxHtml += '<button type="button" class="js-reserve-cancel white">キャンセルする</button>';
								sBoxHtml += '</div>';
							}else{
								sBoxHtml += '<div class="button">';
								sBoxHtml += '<button type="button" disabled class="cancelled">キャンセル済み</button>';
								// sBoxHtml += '<button disabled type="button" class="disabled-btn">キャンセルする</button>';
								sBoxHtml += '</div>';
							}
							sBoxHtml += '</article>';
							$('.js-reserve-list').append(sBoxHtml)
						});
					}
					function paginate() {
						$('.pagination-container').remove();
						$('.js-reserve-list').paginathing({//親要素のclassを記述
								perPage: 50,//1ページあたりの表示件数
								prevText:'<i class="fas fa-angle-left"></i>',//1つ前のページへ移動するボタンのテキスト
								nextText:'<i class="fas fa-angle-right"></i>',//1つ次のページへ移動するボタンのテキスト
								activeClass: 'navi-active',//現在のページ番号に任意のclassを付与できます
								firstLast: false, // 最初と最後のボタンを無効化にする

								// firstText: '<i class="fas fa-angle-double-left"></i>', // "最初ページ"に移動するボタンのテキスト
								// lastText: '<i class="fas fa-angle-double-right"></i>', // "最後のページ"に移動するボタンのテキスト

								disabledClass: 'disable',
						})
					};
					function loadingEnd() {
						// ローディング終了
						$("#loadingOverlay").fadeOut(500, function () {
								$(this).remove();
						})
					}
					$.when(
						addReserveInfo()
					).done(function() {
							paginate(),
							loadingEnd()
						}).fail(function() {
							console.log('エラー');
						});

						/* **************************
							日付を選択したらスクロール
						*/
						smoothScroll()
						function smoothScroll() {
							var screenWidth = window.innerWidth;
							var headerHight = 0;//ヘッダの高さ
							if (screenWidth >= 1079) {
								headerHight = 85;
							}else if(screenWidth <= 1080 ) {
								headerHight = 60;
							}
							var delayTime = 500;
							var position = $('.js-reserve-list').offset().top - headerHight - 30;
							if(screenWidth <= 768 ) {
								$("html, body").delay(delayTime).animate({ scrollTop: position }, 500);
							}
						}
				} else {
					$('.js-reserve-list').html('');
					$.toast({
						heading: 'データの読み込みの際にエラーが発生しました。',
						text: 'お手数ですが、再度お試しいただくか、運営までお問い合わせくださいませ。',
						showHideTransition: 'slide',
						icon: 'error',
						position: 'bottom-right',
						hideAfter: 6000
					});
				}
			}).
			fail(function(oData, sTextStatus, sErrorThrown){
					$('.js-reserve-list').html('');
				$.toast({
					heading: 'データの読み込みに失敗しました',
					text: 'お手数ですが、再度お試しください。',
					showHideTransition: 'slide',
					icon: 'error',
					position: 'bottom-right',
					stack : 1,
					hideAfter: 6000
				});
			}).
			always(function(oData){
			});
		}

		/* **************************
		予約が入っている日を取得（ページを読み込んだ時のカレンダー）
		*/
		$.ajax({
			// 予約日を取得
			url: "/mypage/company/reserve/getReservedDay",
			type:'GET',
			datatype:'json',
			timeout:30000
		}).
		done(function(oData){
			if(oData.status == 'success'){
				// ローディング終了
				$("#loadingOverlay").fadeOut(500, function () {
						$(this).remove();
				})
				/* **************************
				カレンダー設定
				*/
				// event用配列
				var oCalendarEvents = [];
				// クリック可の日付用の配列
				var oCalendarEventsDates = [];
				var oCalendarBody = document.getElementById('calendar-company-reserve');

				$.each(oData.reserved_days, function(index, val) {
					oCalendarEvents.push({
						rendering: 'background',
						color: 'transparent',
						start: val.reserved_day
					});
					oCalendarEventsDates.push(val.reserved_day);
				});

				var oCalendar = new Calendar(oCalendarBody, {
					headerToolbar : {
						left: 'title',
						right: 'prev,next'
					},
					plugins: [ dayGridPlugin, interactionPlugin ],
					locales: [ jaLocale ],
					locale: 'ja',
					contentHeight:"auto",
					events: oCalendarEvents,
					// 日付の「日」を削除
					dayCellContent: function(e) {
						e.dayNumberText = e.dayNumberText.replace('日', '');
					},
					/* **************************
					日付を選択した時
				*/
					dateClick: function(info) {

						if($.inArray(info.dateStr, oCalendarEventsDates)  !== -1) {
							// 予約済み日を選択した時のみ以下を実行
							// カレンダー内日付クリック時
							$("#calendar-company-reserve .date-highlight").removeClass("date-highlight");
							$(info.dayEl).addClass('date-highlight');
							$('.js-reserve-day').val(info.dateStr);
							// ローディング開始
							$(".main").prepend(sLoadingHtml2).hide().fadeIn(100);
							addReserve();
						}else{
							$('.js-reserve-list').html('');
							$('.js-reserve-list').append('<p>ここに予約履歴が表示されます</p>');
							$('.pagination-container').remove();
						}
					},
				});
				$('.fc-bg').removeClass('fc-today');
				oCalendar.render();
			}else {
				// ローディング終了
				$("#loadingOverlay").fadeOut(500, function () {
						$(this).remove();
				})
				$.toast({
					heading: 'データの読み込みの際にエラーが発生しました。',
					text: 'お手数ですが、再度お試しいただくか、運営までお問い合わせくださいませ。',
					showHideTransition: 'slide',
					icon: 'error',
					position: 'bottom-right',
					hideAfter: 6000
				});
			}
		}).
		fail(function(oData, sTextStatus, sErrorThrown){
			$.toast({
				heading: 'データの読み込みに失敗しました',
				text: 'お手数ですが、再度お試しください。',
				showHideTransition: 'slide',
				icon: 'error',
				position: 'bottom-right',
				hideAfter: 6000
			});
		}).
		always(function(oData){});

		/* **************************
			詳細モーダルopen
		*/
    let modal_flg = 1;
    $('button.js-reserve-detail').off(oEventNames.end);
    $(document).on(oEventNames.end, 'button.js-reserve-detail' ,function (event) {
			if (!bIsScrolling) {
				event.preventDefault();
				const item_id = $(this).closest('.reserve-item').attr('data-id');
				var reserveDay = $('.js-reserve-day').val();
				$.ajax({
					url: "/mypage/company/reserve/getReserve/" + reserveDay,
					type: 'get',
					timeout: 3000,
				}).done(function (res) {
					if(res.status == 'success'){
						$.each(res.reserves, function(i, res){
							if(item_id == res.reserve_id) {
								console.log(res);
								var reserveDateTime = moment(res['reserve_datetime']).format('yy/M/D H:mm');
								var reserveDate = moment(res['reserve_datetime']).format('yy/M/D');
								var startDateTime = moment(res['start_time']).format('yy/M/D H:mm');
								var endDateTime = moment(res['end_time']).format('yy/M/D H:mm');
								var date = startDateTime + ' 〜 ' + endDateTime + '（' + res['require_time'] + '）';
								if (modal_flg == 1) {
									const $modal = $('#modal-company-reserve-detail');
									MicroModal.show('modal-company-reserve-detail', {
										awaitCloseAnimation: true,
										disableScroll: true
									});
									if(res['cancelable_company'] == false) {
										$modal.find('.cancel-wrap').html('');
										var cancelUser = '';
										if(res['cancel_user_type'] == 1) {
											var cancelUser = '患者ユーザー';
										}else if(res['cancel_user_type'] == 2) {
											var cancelUser = '業者ユーザー';
										}else{
											var cancelUser = '運営者アカウント';
										}
										var cancelDate = moment(res['cancel_datetime']).format('yy/M/D H:mm');
										$modal.find('.cancel-wrap').html('');
										$modal.find('.cancel-wrap').append('<div class="reserve-cancel"><div class="reserve-cancel__wrap"><p class="alert alert-secondary alert-original"><i class="fas fa-minus-circle"></i><span>この予約は<strong>'+ cancelUser +'</strong>によりキャンセル済みです。</span></p><h3 class="reserve-cancel__wrap__title">キャンセル理由</h3><p class="reserve-cancel__wrap__reason">'+ res['cancel_reason'] +'</p><dl class="reserve-cancel__wrap__date"><dt>キャンセル日</dt><dd><time datetime="">' + cancelDate + '</time></dd></dl></div></div>');
									}else{
										$modal.find('.cancel-wrap').html('');
									}
									// 患者相談タイトル
									$modal.find('.quote-user-title').text(res['title']);
									// 患者氏名
									$modal.find('.quote-user-name').html('');
									var userName = res['user_name'] + '（' + res['user_nickname'] + '）';
									var sAppendItem = '';
									sAppendItem += '<div class="table-tell">';
									sAppendItem += ' <p class="user-name">'+ userName +'</p>';
									sAppendItem += ' <p class="button"><a href="tel:'+ res['user_tell']  + '"><i class="fas fa-phone-alt"></i>電話をする</a></p>';
									sAppendItem += '</div>';
									$modal.find('.quote-user-name').append(sAppendItem);

									// 出発地の施設・病院名称
									if(res['pickup']) {
										$('.quote-pickup-wrap').show();
										$modal.find('.quote-pickup').html(res['pickup']);
									}else{
										$modal.find('.quote-pickup').html('');
										$('.quote-pickup-wrap').hide();
										$modal.find('.quote-pickup').html(res['']);
									}
									// 出発地の所在地
									$modal.find('.quote-addr').html(res['state'] + res['addr']);

									// 目的地の施設・病院名称
									if(res['destination']) {
										$('.quote-dest-name-wrap').show();
										$modal.find('.quote-dest-name').html(res['destination']);
									}else{
										$modal.find('.quote-dest-name').html('');
										$('.quote-dest-name-wrap').hide();
										$modal.find('.quote-dest-addr').html(res['']);
									}
									// 目的地の所在地
									$modal.find('.quote-dest-addr').html(res['dest_state'] + res['dest_addr']);

									// 詳細内容・病名など伝達事項
									$modal.find('.quote-detail-text').html(res['quote_detail']);
									// 実施日時
									$modal.find('.quote-implement-date').text(date);
									// 支払い方法
									if(res['payment_type']) {
										$('.payment_type-wrap').show();
										$modal.find('.quote-payment_type').html(res['payment_type']);
										if( res['payment_type'] === '事前クレジットカード払い') {
											if(res['stripe_transfer_date']) {
												$('.stripe_transfer_date-wrap').show();
												$modal.find('.quote-stripe_transfer_date').html(res['stripe_transfer_date']);
											}else{
												$('.stripe_transfer_date-wrap').show();
												$modal.find('.quote-stripe_transfer_date').html('患者さまが予約を完了した日（'+reserveDate+'）から40日程度で送金されます。');
											}
										}else{
											$modal.find('.quote-stripe_transfer_date').html('');
											$('.stripe_transfer_date-wrap').hide();
										}
									}else{
										$modal.find('.quote-payment_type').html('');
										$('.payment_type-wrap').hide();
									}
									// 業者見積もりタイトル
									$modal.find('.quote-company-title').text(res['answer_title']);
									// 業者見積もり詳細
									if(res['answer_detail']) {
										$('.answer_detail-wrap').show();
										$modal.find('.quote-answer_detail').html(res['answer_detail']);
									}else{
										$modal.find('.quote-answer_detail').html('');
										$('.answer_detail-wrap').hide();
									}
									$modal.find('.quote-company-detail').text(res['answer_detail']);
									// 正式見積もり金額
									if(res['amount']) {
										var amount = Number(res['amount']).toLocaleString() + '円';
										$modal.find('.price-wrap').show();
										$modal.find('.quote-price').html(amount);
									}else{
										$modal.find('.quote-price').html('');
										$('.price-wrap').hide();
									}
									// 必要とする介助要員
									if(res['care_humans']) {
										$('.care_humans-wrap').show();
										$modal.find('.quote-care_humans').html(res['care_humans']);
									}else{
										$modal.find('.quote-care_humans').html('');
										$('.care_humans-wrap').hide();
									}
									// 必要な資器材
									$modal.find('.quote-equips').html(res['equips']);
									// 帰路迎車の有無
									// $modal.find('.flg_pickup').html(res['flg_pickup']);
									if(res['flg_pickup']) {
										$('.flg_pickup-wrap').show();
										$modal.find('.quote-flg_pickup').html(res['flg_pickup'] + '人');
									}else{
										$modal.find('.quote-flg_pickup').html('');
										$('.flg_pickup-wrap').hide();
									}
									// 同乗者の人数
									if(res['fellow_passengers']) {
										$('.fellow_passenger-wrap').show();
										$modal.find('.quote-fellow_passengers').html(res['fellow_passengers'] + '人');
									}else{
										$modal.find('.quote-fellow_passengers').html('');
										$('.fellow_passenger-wrap').hide();
									}
									// 障がい者手帳の有無
									if(res['flg_handicap_pass'] === 'あり') {
										$modal.find('.quote-nashi_ari_handicap_pass').html(res['flg_handicap_pass']);
									}else{
										$modal.find('.quote-nashi_ari_handicap_pass').text('なし');
									}
									// 市・区などから交付される福祉タクシー券の有無
									if(res['flg_taxi_ticket'] === 'あり' ) {
										$('.flg_taxi_ticket-wrap').show();
										$modal.find('.quote-flg_taxi_ticket').html('');
										$modal.find('.quote-flg_taxi_ticket').html(res['flg_taxi_ticket']);
										// タクシー券の利用額
										if(res['taxi_ticket_amount']) {
											var taxi_ticket_amount = Number(res['taxi_ticket_amount']).toLocaleString() + '円';
											$modal.find('.quote-taxi_ticket_amount').html(taxi_ticket_amount);
										}else{
											$modal.find('.quote-taxi_ticket_amount').html('');
										}
									}else{
										$modal.find('.quote-flg_taxi_ticket').text('なし');
										$('.taxi_ticket_amount-wrap').hide();
									}
									// 建物内への介助が必要か
									if(res['flg_indoor_care'] === '必要') {
										$modal.find('.quote-flg_indoor_care').html(res['flg_indoor_care']);
										// 階数
										if(res['floor']) {
											$modal.find('.quote-floor').html(res['floor']+'階');
										}else{
											$modal.find('.quote-floor').html('');
										}
										// 対象階への移動手段
										if(res['transportation']) {
											$modal.find('.quote-transportation').html(res['transportation']);
										}else{
											$modal.find('.quote-transportation').html('');
										}
									}else{
										$modal.find('.quote-flg_indoor_care').html('不要');
										$('.floor-wrap, .transportation-wrap').hide();
									}
									// 依頼のタイミング
									$modal.find('.quote-timing').html(res['request_timing']);
									// 希望する業者種別
									$modal.find('.quote-request_company_type').html(res['request_company_type'] );
									// 相談メニュー
									$modal.find('.quote-request_category').html(res['request_category']);
									// 予約をした日時
									$modal.find('.quote-reserve-date').text(reserveDateTime);
								}
							}
						});
					}else{
						$.toast({
							heading: 'データの読み込みの際にエラーが発生しました。',
							text: 'お手数ですが、再度お試しいただくか、運営までお問い合わせくださいませ。',
							showHideTransition: 'slide',
							icon: 'error',
							position: 'bottom-right',
							hideAfter: 6000
						});
					}
				}).
				fail(function(oData, sTextStatus, sErrorThrown){
					$.toast({
						heading: 'データの読み込みに失敗しました',
						text: 'お手数ですが、再度お試しください。',
						showHideTransition: 'slide',
						icon: 'error',
						position: 'bottom-right',
						hideAfter: 6000
					});
				}).
				always(function(oData){});
			}
    });

		/* **************************
			キャンセルモーダルopen
		*/
    $(document).on(oEventNames.end,'button.js-reserve-cancel',function (event) {
      const cancelItem_id = $(this).closest('.reserve-item').attr('data-id');
			$('.js-reserve-id').val(cancelItem_id);
			if (!bIsScrolling) {
				event.preventDefault();

				var reserveDay = $('.js-reserve-day').val();
				$.ajax({
					url: "/mypage/company/reserve/getReserve/" + reserveDay,
					type: 'get',
					timeout: 3000,
				}).done(function (res) {
					if(res.status == 'success'){
						// 以下がクリックした予約の詳細モーダル内の表組みに入れるデータです
						$.each(res.reserves, function(i, res){
							if(cancelItem_id == res.reserve_id) {
								// キャンセル時間72時間前を算出・出力
								var reseveDateTimeLimit = moment(res['start_time']).format('yy/M/D H:mm');
								var reseveDateTimeLimit = new Date(reseveDateTimeLimit);
								var reseveDateTimeLimit = reseveDateTimeLimit.setHours(reseveDateTimeLimit.getHours() - 72);
								if (modal_flg == 1) {
									const $modal = $('#modal-reserve-cancel');
									$modal.find('.limit-time').text(moment(reseveDateTimeLimit).format('yy/M/D H:mm'));
								}
							}
						});
						// キャンセルモーダルを閉じた時のアクション
						function onClose() {
							// テキストエリアを空にする
							$('.js-cancel-textarea').val('');
							// キャンセル確定ボタンをdisabledにする
							$('button.js-cancel-submit').addClass('disabled-btn');
							$('button.js-cancel-submit').prop('disabled', true);
						}
						MicroModal.show('modal-reserve-cancel', {
							awaitCloseAnimation: true,
							disableScroll: true,
							onClose: onClose
						});
						autosize($('.autosize'));
					}else{
						const $modal = $('#modal-reserve-cancel');
						$modal.find('.limit-time').text('');
						// $.toast({
						// 	heading: '読み込みに失敗しました',
						// 	text: 'お手数ですが、再度お試しいただくか、運営までお問い合わせくださいませ。',
						// 	showHideTransition: 'slide',
						// 	icon: 'error',
						// 	position: 'bottom-right',
						// 	hideAfter: 6000
						// });
					}
				}).
				fail(function(oData, sTextStatus, sErrorThrown){
						const $modal = $('#modal-reserve-cancel');
						$modal.find('.limit-time').text('');
					// $.toast({
					// 	heading: 'データの読み込みに失敗しました',
					// 	text: 'お手数ですが、再度お試しください。',
					// 	showHideTransition: 'slide',
					// 	icon: 'error',
					// 	position: 'bottom-right',
					// 	hideAfter: 6000
					// });
				}).
				always(function(oData){});
			}
    });
			/* **************************
			キャンセル理由に文字を追加したらキャンセル確定ボタンを押下可能とする
			空白や改行は除く
		*/
		if($(".js-cancel-textarea").length){
			$(".js-cancel-textarea").on("input",(function(){
				var t = $(this).val().replace(/\s+/g,"").length;
				if(t > 0) {
					$('button.js-cancel-submit').removeClass('disabled-btn');
					$('button.js-cancel-submit').prop('disabled', false);
				}else{
					$('button.js-cancel-submit').addClass('disabled-btn');
					$('button.js-cancel-submit').prop('disabled', true);
				}
			}));
		}
		/* **************************
			キャンセル確定ボタン押下
		*/
			$(document).on(oEventNames.end,'button.js-cancel-submit:not(.disabled-btn)', function (event) {
				event.preventDefault();
				if (!bIsScrolling) {
					// ローディング開始
					$(".main").prepend(sLoadingHtml2).hide().fadeIn(100);
					var reserveId = $('.js-reserve-id').val();
					var reason = $('.js-cancel-textarea').val();
					let data = {
							"reserve_id" : reserveId,
							"reason"        : reason
					}
					$.ajax({
						type: "POST",
						url: "/mypage/company/reserve/cancel",
						data: JSON.stringify(data),
						contentType: "application/json; charset=utf-8",
						dataType : "json",
						cache: false,
						processData: false,
						headers: {
								'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
						}
					}).
					done(function(oData){
						if(oData.status == 'success'){

							MicroModal.close('modal-reserve-cancel');
							$.toast({
								heading: '予約のキャンセルが完了しました。',
								showHideTransition: 'slide',
								icon: 'success',
								position: 'bottom-right',
								hideAfter: 6000,
							});
							addReserve();
							// ローディング終了
							$("#loadingOverlay").fadeOut(500, function () {
									$(this).remove();
								})
						}else{
							MicroModal.close('modal-reserve-cancel');
							$.toast({
								heading: '予約のキャンセルが失敗しました。',
								text: 'お手数ですが再度お試しいただき、それでも失敗するようでしたら運営会社まで直接ご連絡ください。',
								showHideTransition: 'slide',
								icon: 'error',
								position: 'bottom-right',
								hideAfter: 6000
							});
							// ローディング終了
							$("#loadingOverlay").fadeOut(500, function () {
									$(this).remove();
							})
						}
					}).
					fail(function(oData){
						// ローディング終了
						$("#loadingOverlay").fadeOut(500, function () {
								$(this).remove();
						})
						$.toast({
							heading: 'データの読み込みに失敗しました',
							text: 'お手数ですが、再度お試しください。',
							showHideTransition: 'slide',
							icon: 'error',
							position: 'bottom-right',
							hideAfter: 6000
						});
					}).
					always(function(oData){
							// ローディング終了
							$("#loadingOverlay").fadeOut(500, function () {
									$(this).remove();
							})
					});
				}
			});
	}
});
